import React from 'react';
import { Box, Paper, Typography, Button, Stack } from '@mui/material';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';

export interface EventItem {
  id: number;
  title: string;
  venue: string;
  start_at: string;
  open_at: string | null;
}

interface EventListProps {
  onSelect: (event: EventItem) => void;
}

const staticEvents: EventItem[] = [
  {
    id: 1,
    title: 'もんクエ',
    venue: '仙台駅周辺',
    start_at: '2025-12-31T12:00:00+09:00',
    open_at: null,
  },
  /*
  {
    id: 2,
    title: 'もん王',
    venue: 'オンライン',
    start_at: '2025-12-31T12:00:00+09:00',
    open_at: null,
  }
  */
];

const EventList: React.FC<EventListProps> = ({ onSelect }) => {
  const events = staticEvents;

  return (
    <Box sx={{ width: '100%', pt: { xs: 7, sm: 8 }, pb: 2 }}>
      {events.length === 0 ? (
        <Paper sx={{ p: 4, textAlign: 'center' }}>
          <Typography color="text.secondary">現在開催中のイベントはありません</Typography>
        </Paper>
      ) : (
        <Stack spacing={2}>
          {events.map((event) => (
            <Paper key={event.id} sx={{ p: 2 }}>
              <Stack direction="row" alignItems="center" spacing={2}>
                <EventAvailableIcon sx={{ color: '#d81b60' }} />
                <Typography variant="h6" sx={{ fontWeight: 700, flex: 1 }}>
                  {event.title}
                </Typography>
                <Button variant="contained" size="small" onClick={() => onSelect(event)}>
                  入場
                </Button>
              </Stack>
            </Paper>
          ))}
        </Stack>
      )}
    </Box>
  );
};

export default EventList;
